import { uiState } from "../../state/uiState.js";
import { renderKisilerGrid, clearKisilerGrid } from "./kisilerGrid.js";
import { truncateLabel } from "../../utils/textPresentation.js";

const API = "/api";
let didBound = false;

function showFilterOverlay(container) {
    let ov = container.querySelector(".filter-loading-overlay");
    if (!ov) {
        ov = document.createElement("div");
        ov.className = "filter-loading-overlay";
        ov.innerHTML = `<div class="filter-loading-spinner"></div><span class="filter-loading-text">Yükleniyor...</span>`;
        container.appendChild(ov);
    }
    ov.classList.remove("hidden");
}

function hideFilterOverlay(container) {
    container.querySelector(".filter-loading-overlay")?.classList.add("hidden");
}

async function withFilterOverlay(container, fn) {
    showFilterOverlay(container);
    try { await fn(); }
    finally {
        await new Promise(r => setTimeout(r, 300));
        hideFilterOverlay(container);
    }
}

export function resetKisilerFilters() {
    const departmanSelect = document.querySelector("#kisiler-departman");
    const unvanSelect = document.querySelector("#kisiler-unvan");
    const tcInput = document.querySelector("#kisiler-tc-filter");
    const adInput = document.querySelector("#kisiler-ad-filter");
    const soyadInput = document.querySelector("#kisiler-soyad-filter");
    const durumSelect = document.querySelector("#kisiler-durum-filter");
    const badge = document.querySelector("#kisiler-filter-section .filter-aktif-badge");
    const countEl = document.getElementById("kisiler-count");

    if (departmanSelect) departmanSelect.value = "";
    if (unvanSelect) unvanSelect.value = "";
    if (tcInput) tcInput.value = "";
    if (adInput) adInput.value = "";
    if (soyadInput) soyadInput.value = "";
    if (durumSelect) durumSelect.value = "";

    uiState.kisiler.filters.departman_id = "";
    uiState.kisiler.filters.unvan_id = "";
    uiState.kisiler.filters.tc = "";
    uiState.kisiler.filters.ad = "";
    uiState.kisiler.filters.soyad = "";
    uiState.kisiler.filters.durum = "";

    clearKisilerGrid();
    if (badge) badge.hidden = true;
    if (countEl) countEl.textContent = "";
}

export function initKisilerFilters() {
    const sectionBody     = document.querySelector("#kisiler-filter-section .section-body");
    const departmanSelect = document.querySelector("#kisiler-departman");
    const unvanSelect     = document.querySelector("#kisiler-unvan");
    const tcInput         = document.querySelector("#kisiler-tc-filter");
    const adInput         = document.querySelector("#kisiler-ad-filter");
    const soyadInput      = document.querySelector("#kisiler-soyad-filter");
    const durumSelect     = document.querySelector("#kisiler-durum-filter");
    const searchBtn       = document.querySelector(".kisiler-search");
    const resetBtn        = document.querySelector(".kisiler-filter-reset");
    const badge           = document.querySelector("#kisiler-filter-section .filter-aktif-badge");

    async function loadDropdown(url, selectEl) {
        // Mevcut seçenekleri temizle (ilk "Tümü" option hariç)
        while (selectEl.options.length > 1) selectEl.remove(1);
        try {
            const res = await fetch(`${API}${url}`);
            const data = await res.json();
            (data.items || []).forEach((item) => {
                const fullLabel = String(item.name ?? "");
                const opt = document.createElement("option");
                opt.value = item.id;
                opt.textContent = truncateLabel(fullLabel, 32);
                opt.title = fullLabel;
                selectEl.appendChild(opt);
            });
            const selected = selectEl.options?.[selectEl.selectedIndex];
            selectEl.title = selected?.title?.trim?.() || selected?.textContent?.trim() || "";
        } catch (err) {
            console.error(`❌ ${url} yüklenemedi:`, err);
        }
    }

    // Her sayfa ziyaretinde dropdown'ları yeniden yükle
    if (sectionBody) {
        withFilterOverlay(sectionBody, () => Promise.all([
            loadDropdown("/kisi-departmanlari", departmanSelect),
            loadDropdown("/unvanlar", unvanSelect),
        ])).catch((err) => console.error("❌ Kişiler dropdown init hatası:", err));
    } else {
        Promise.all([
            loadDropdown("/kisi-departmanlari", departmanSelect),
            loadDropdown("/unvanlar", unvanSelect),
        ]).catch((err) => console.error("❌ Kişiler dropdown init hatası:", err));
    }

    if (didBound) return;
    didBound = true;

    departmanSelect?.addEventListener("change", () => {
        uiState.kisiler.filters.departman_id = departmanSelect.value;
    });
    unvanSelect?.addEventListener("change", () => {
        uiState.kisiler.filters.unvan_id = unvanSelect.value;
    });
    tcInput?.addEventListener("input", () => {
        tcInput.value = tcInput.value.replace(/\D/g, "").slice(0, 11);
        uiState.kisiler.filters.tc = tcInput.value;
    });
    adInput?.addEventListener("input", () => {
        uiState.kisiler.filters.ad = adInput.value.trim();
    });
    soyadInput?.addEventListener("input", () => {
        uiState.kisiler.filters.soyad = soyadInput.value.trim();
    });
    durumSelect?.addEventListener("change", () => {
        uiState.kisiler.filters.durum = durumSelect.value;
    });

    searchBtn?.addEventListener("click", () => {
        const params = new URLSearchParams();
        const { departman_id, unvan_id, tc, ad, soyad, durum } = uiState.kisiler.filters;
        if (departman_id) params.append("departman_id", departman_id);
        if (unvan_id) params.append("unvan_id", unvan_id);
        if (tc) params.append("tc", tc);
        if (ad) params.append("ad", ad);
        if (soyad) params.append("soyad", soyad);
        if (durum !== "") params.append("durum", durum);
        const qs = params.toString();
        const url = qs ? `${API}/kisiler?${qs}` : `${API}/kisiler`;
        renderKisilerGrid({ url, paginationLimit: uiState.kisiler.paginationLimit });
        if (badge) badge.hidden = !qs;
    });

    resetBtn?.addEventListener("click", () => {
        resetKisilerFilters();
    });
}
